import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import ContentStackApi from '@api/ContentStack'

export default {

  // Monkey patch for dumb design decision, refactor later?
  [actionTypes.GET_CLOUD_CANNON_FOOTER_CONTENT](context) {
    context.commit(mutationTypes.SET_CLOUD_CANNON_FOOTER_CONTENT_LOADING, true)
    return new ContentStackApi()
      .getContentStackContent({
        cloudCannonResource: '/footer.json'
      })
      .then(response => {
        context.commit(mutationTypes.SET_CLOUD_CANNON_FOOTER_CONTENT, response)
      })
      .catch(_ => {
        /* todo */
      })
      .finally(() => {
        context.commit(
          mutationTypes.SET_CLOUD_CANNON_FOOTER_CONTENT_LOADING,
          false
        )
      })
  },

  [actionTypes.GET_CLOUD_CANNON_CONTENT](context, options = {}) {
    context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT_LOADING, true)
    // return new CloudCannonApi()
    //   getCloudCannonContent({
    return new ContentStackApi()
      .getContentStackContent({
        cloudCannonResource: options.cloudCannonResource
      })
      .then(response => {
        context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT, response)
      })
      .catch(_ => {
        /* todo */
      })
      .finally(() => {
        context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT_LOADING, false)
      })
  },

  [actionTypes.GET_CONTENTSTACK_CONTENT](context, options = {}) {
    context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT_LOADING, true)
    return new ContentStackApi()
      .getContentStackContent({
        cloudCannonResource: options.cloudCannonResource
      })
      .then(response => {
        context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT, response)
      })
      .catch(_ => {
        /* todo */
      })
      .finally(() => {
        context.commit(mutationTypes.SET_CLOUD_CANNON_CONTENT_LOADING, false)
      })
  }
}
